


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTHOMESECTION
// REJECTHOMESECTION


const REJECTHOMESECTION= createAsyncThunk(
  "rejectHomeSection/rejectHomeSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectHomeSectionSlice = createSlice({
  name: "rejectHomeSectionSlice",
  initialState: {
    rejectHomeSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectHomeSection: (state) => {
        state.rejectHomeSection.loading = false
        state.rejectHomeSection.error = false
        state.rejectHomeSection.data = []
        state.rejectHomeSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTHOMESECTION.fulfilled, (state, action) => {
      state.rejectHomeSection = {
        ...state.rejectHomeSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTHOMESECTION.pending, (state, action) => {
      state.rejectHomeSection = {
        ...state.rejectHomeSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTHOMESECTION.rejected, (state, action) => {
      state.rejectHomeSection = {
        ...state.rejectHomeSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectHomeSectionAction = {
    REJECTHOMESECTION,
};

export { rejectHomeSectionAction };
export default rejectHomeSectionSlice.reducer;
export const {setInitialStateOfrejectHomeSection} = rejectHomeSectionSlice.actions
